"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sahaTuruListeSuzgeciSchema = exports.ekipAdaylariSchema = exports.ekipAdayiSchema = exports.sahaTuruSecenekleriSchema = exports.sahaTuruListesiSchema = exports.sahaTuruDetaySchema = exports.sahaTuruOzetSchema = exports.sahaTuruEkiSchema = exports.tatbikatSchema = exports.sahaTuruYetkileriSchema = exports.sahaTuruDenetimFormuSchema = exports.denetimUygunsuzMaddesiSchema = exports.gozlemListesiSchema = exports.gozlemSchema = exports.gozlemFotografiSchema = exports.sahaTuruEkipUyesiSchema = exports.sahaTuruBulguOzetiSchema = exports.sahaTuruKapatSchema = exports.gozlemOlusturSchema = exports.GOZLEM_METIN_MAX = exports.sahaTuruEkipEkleSchema = exports.sahaTuruOlusturSchema = exports.tatbikatGirdiSchema = exports.TATBIKAT_SENARYO_MAX = exports.SAHA_TURU_GOMULU_FORM_SORULMAYAN_ALANLAR = exports.SAHA_TURU_TAKIP_ONEKI = exports.GOZLEM_TIP_ETIKETI = exports.SAHA_TURU_DURUM_ETIKETI = exports.SAHA_TURU_TIP_ETIKETI = exports.gozlemTipiSchema = exports.GOZLEM_TIPLERI = exports.sahaTuruDurumuSchema = exports.SAHA_TURU_DURUMLARI = exports.SAHA_TURU_TIP_ALANLARI = exports.SAHA_TURU_KUNYE_ALANLARI = exports.sahaTuruTipiSchema = exports.SAHA_TURU_TIPLERI = void 0;
exports.sahaTuruAlaniVarMi = sahaTuruAlaniVarMi;
exports.formKapSemasi = formKapSemasi;
exports.formKaydiBulguKaynagiMi = formKaydiBulguKaynagiMi;
exports.sahaTuruYazilabilirMi = sahaTuruYazilabilirMi;
exports.sahaTuruKapanisEngeli = sahaTuruKapanisEngeli;
exports.gozlemBulguOlabilirMi = gozlemBulguOlabilirMi;
exports.bulguAciklamasi = bulguAciklamasi;
exports.sahaTuruSuzgecOzeti = sahaTuruSuzgecOzeti;
const zod_1 = require("zod");
const acil_durum_1 = require("./acil-durum");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * SAHA TURU / DENETİM — KURAL VE SÖZLEŞME KATMANI (Kapsam §27; ERD §10g —
 * 05.09.2026; sertleştirme programı sonrası İLK yapım turu).
 *
 * ════════════════════════════════════════════════════════════════════════
 * TURUN TEK CÜMLESİ: KAP BELİRLER
 * ════════════════════════════════════════════════════════════════════════
 *
 * Aynı form **rutin görevde bulgu üretmez, denetim oturumunda üretir.** Kap
 * `form_submission.site_tour_id`dir ve kural bu dosyadaki TEK yüklemden
 * okunur (`formKaydiBulguKaynagiMi`). Form motoru bulgu DOĞURMAZ (U10 aynen):
 * bulguyu turun KAPANIŞI ve liderin SEÇİMİ doğurur (S4/S9).
 *
 * ⚠️ Modül yeni nesne icat etmez — form motoru + uygunsuzluk üstünde bir
 * KAPTIR. Bulgu bir `nonconformity` satırıdır; bağın evi GÖZLEM satırıdır
 * (`nonconformity_id` UNIQUE). KPI türetilir: bulgu sayısı · kaçı kapandı —
 * uygunsuzluk kapanış okuyucusundan (`olayKapaliMi`), ikinci sayım yok.
 */
// ── Enum'lar (İngilizce token — §10) ─────────────────────────────────────
/**
 * ✏️ ACİL DURUM (06.09.2026 — Kapsam §29/E5): ÜÇÜNCÜ TİP `tatbikat`. Tatbikat
 * bir saha turu KABIDIR — gözlem · bulgu · tutanak mekanizması aynen; ek
 * alanlar (senaryo · tür · süre · tahliye sayısı · katılan ekipler) turun
 * kendi satırında, YALNIZ bu tipte dolu. ⚠️ Tip okuyan her koşul POZİTİF
 * yazılır (`=== 'denetim'`); `!== 'gozlem'` biçimi bu genişlemede sessizce
 * yanlışa dönerdi (0b token envanteri — üç `gozlem` koşulu çevrildi).
 */
exports.SAHA_TURU_TIPLERI = ['gozlem', 'denetim', 'tatbikat'];
exports.sahaTuruTipiSchema = zod_1.z.enum(exports.SAHA_TURU_TIPLERI);
/**
 * ✏️ **KA-6 — SEKMEYE AİT OLMAYAN ALAN O SEKMEDE GÖRÜNMEZ** (küçük A paketi /
 * bulgu 18; Kapsam §14 KA-6, Yönerge §4). Tipe bağlı künye alanlarının TEK
 * envanteri: açılış ekranı · tur künyesi · tutanak PDF'i · sunucu şeması bunu
 * okur. İşyeri · lokasyon · tarih her tipte ortaktır (envantere girmez).
 * *Denetlenen birim* tatbikatın alanı DEĞİLDİR — ekranda çizilip sunucuda
 * kabul edildiği için tip değişince eski seçim sessizce taşınıyordu.
 */
exports.SAHA_TURU_KUNYE_ALANLARI = ['birim', 'sablon', 'tatbikat'];
exports.SAHA_TURU_TIP_ALANLARI = {
    gozlem: ['birim'],
    denetim: ['birim', 'sablon'],
    tatbikat: ['tatbikat'],
};
function sahaTuruAlaniVarMi(tip, alan) {
    return exports.SAHA_TURU_TIP_ALANLARI[tip].includes(alan);
}
exports.SAHA_TURU_DURUMLARI = ['acik', 'kapali'];
exports.sahaTuruDurumuSchema = zod_1.z.enum(exports.SAHA_TURU_DURUMLARI);
exports.GOZLEM_TIPLERI = ['uygunsuz', 'olumlu'];
exports.gozlemTipiSchema = zod_1.z.enum(exports.GOZLEM_TIPLERI);
/** Ekran ve PDF AYNI haritayı okur (D2 — enum ekrana inmez). */
exports.SAHA_TURU_TIP_ETIKETI = {
    gozlem: 'Gözlem turu',
    denetim: 'Denetim',
    tatbikat: 'Tatbikat',
};
exports.SAHA_TURU_DURUM_ETIKETI = {
    acik: 'Açık',
    kapali: 'Kapalı',
};
exports.GOZLEM_TIP_ETIKETI = {
    uygunsuz: 'Uygunsuz',
    olumlu: 'Olumlu',
};
/** Takip numarası öneki — olay `OLY-` · uygunsuzluk `UYG-` · saha turu `STR-`. */
exports.SAHA_TURU_TAKIP_ONEKI = 'STR-';
// ── Yüklemler (tek kaynak) ────────────────────────────────────────────────
/**
 * T4 (türetme paketi — madde 265 / bulgu 56, 17.09.2026; Kapsam §14 T4 · §27.4 ✏️):
 * GÖMÜLÜ FORM ÜST KAYDIN BİLDİĞİNİ SORMAZ. Tur künyesinin *Denetlenen birim*i
 * (sözlük) ile şablonun kilitli ürün alanı *Denetlenen bölüm / faaliyet*
 * (serbest metin) aynı şey değildir ve EŞLENMEZ — gömülü kullanımda şablondaki
 * alan susturulur, künyedeki alan tek kaynaktır. Bağımsız doldurmada görünür.
 *
 * ⚠️ Şablona koşul YAZILMAZ (`kosul` yasağı aynen): hangi alanın susacağı
 * KAPTAN türetilir ve form motorunun MEVCUT `gizli` mekanizmasına biner —
 * gizli alan ekranda çizilmez, zorunluluk denetiminde atlanır, cevap kabul
 * etmez, çıktıya basılmaz. Doğrulama · ekran · form PDF'i · tur tutanağı bu
 * dönüşümden geçmiş şemayı okur; ikinci bir muafiyet dalı yoktur.
 */
exports.SAHA_TURU_GOMULU_FORM_SORULMAYAN_ALANLAR = ['denetlenen_bolum'];
function formKapSemasi(sema, kap) {
    if (!kap.siteTourId)
        return sema;
    return {
        ...sema,
        alanlar: sema.alanlar.map((alan) => exports.SAHA_TURU_GOMULU_FORM_SORULMAYAN_ALANLAR.includes(alan.kod) ? { ...alan, gizli: true } : alan),
    };
}
/**
 * S2 — KAP BELİRLER: bir form kaydının uygunsuz maddeleri BULGU ADAYI mıdır?
 * Cevap kaydın KABINDADIR: bir denetim oturumuna bağlıysa evet, değilse
 * hayır. Uç, kapanış servisi ve ekran rozeti HEPSİ bunu çağırır — ikinci bir
 * koşul ("şablon saha denetimi mi", "atama var mı") YAZILMAZ.
 */
function formKaydiBulguKaynagiMi(kayit) {
    return kayit.siteTourId !== null;
}
/** S9 — açık tura yazılır; kapalı tur yeniden açılmaz (409 kodda). */
function sahaTuruYazilabilirMi(durum) {
    return durum === 'acik';
}
/**
 * S9 — KAPANIŞ ENGELİ. `null` = kapatılabilir; metin = pasif düğmenin
 * YANINDA gösterilen sebep (G5: sebep düğmenin yanında, sayfanın altında
 * değil). Sunucunun `assert`i AYNI yüklemi çağırır (§2.40 — kapı ile
 * görünürlük tek cümleden).
 */
function sahaTuruKapanisEngeli(tur) {
    if (tur.durum !== 'acik')
        return 'Tur zaten kapalı';
    if (!tur.lider)
        return 'Turu yalnız lider kapatabilir';
    if (tur.tip === 'denetim' && !tur.formGonderildi)
        return 'Önce denetim formunu gönderin';
    return null;
}
/** S3 — yalnız UYGUNSUZ gözlem bulgu olabilir (DB CHECK'in kural yarısı). */
function gozlemBulguOlabilirMi(tip) {
    return tip === 'uygunsuz';
}
/**
 * S5 — bulgu açıklaması: gözlem metni + atıf (varsa). Uygunsuzluk kaydında
 * atıf için kolon YOKTUR (U3 — kayıt sınıflandırmasızdır); atıf metne
 * TAŞINIR. Gözlem satırı kopyayı ayrıca saklar (tutanak değişmez).
 */
function bulguAciklamasi(metin, atif) {
    const govde = metin.trim();
    return atif && atif.trim() ? `${govde}\nAtıf: ${atif.trim()}` : govde;
}
// ── İstek şemaları ────────────────────────────────────────────────────────
exports.TATBIKAT_SENARYO_MAX = 2000;
/**
 * E5 — tatbikatın ek alanları. `ekipGorevlendirmeTuruIds` = katılan ekipler:
 * görevlendirme türü NÜSHA kimlikleri; sunucu her birinin acil durum ekibi
 * olduğunu doğrular (`acilDurumEkibiMi` — ref'e bakar, ada değil).
 */
exports.tatbikatGirdiSchema = zod_1.z.object({
    /** G4.1 — ÇOKLU: en az bir tür; tekrar eden değer sunucuda tekilleştirilir. */
    turler: zod_1.z.array(acil_durum_1.tatbikatTuruSchema).min(1, 'Tatbikat için en az bir tür seçin'),
    senaryo: zod_1.z.string().trim().min(1).max(exports.TATBIKAT_SENARYO_MAX),
    sureDakika: zod_1.z
        .number()
        .int()
        .positive()
        .max(24 * 60)
        .nullable()
        .optional(),
    tahliyeKisiSayisi: zod_1.z.number().int().min(0).max(100_000).nullable().optional(),
    ekipGorevlendirmeTuruIds: zod_1.z.array(zod_1.z.uuid()).max(20).default([]),
});
/**
 * Tur açma (S1 · S8). Denetimde şablon ZORUNLU, diğer tiplerde YASAK (DB
 * CHECK `site_tour_denetim_sablonu`nun kural yarısı). Tatbikatta ek alanlar
 * ZORUNLU, diğer tiplerde YASAK (`site_tour_tatbikat_alanlari` CHECK'inin
 * kural yarısı). Ekip kişileri isteğe bağlı — lider ekipte otomatik durur.
 */
exports.sahaTuruOlusturSchema = zod_1.z
    .object({
    tip: exports.sahaTuruTipiSchema,
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullable().optional(),
    birimRefId: zod_1.z.uuid().nullable().optional(),
    formTemplateId: zod_1.z.uuid().nullable().optional(),
    tarih: zod_1.z.iso.date(),
    ekipPersonIds: zod_1.z.array(zod_1.z.uuid()).max(50).default([]),
    /** E5 — yalnız `tip = tatbikat`ta dolu; diğer tiplerde YASAK (CHECK'in kural yarısı). */
    tatbikat: exports.tatbikatGirdiSchema.nullable().optional(),
})
    .superRefine((g, ctx) => {
    // KA-6: tipe ait olmayan alan REDDEDİLİR — envanter tek kaynak.
    if (!sahaTuruAlaniVarMi(g.tip, 'birim') && (g.birimRefId ?? null) !== null) {
        ctx.addIssue({
            code: 'custom',
            path: ['birimRefId'],
            message: 'Denetlenen birim bu tur tipinde girilmez',
        });
    }
    const sablon = g.formTemplateId ?? null;
    if (sahaTuruAlaniVarMi(g.tip, 'sablon') && sablon === null) {
        ctx.addIssue({
            code: 'custom',
            path: ['formTemplateId'],
            message: 'Denetim için form şablonu seçin',
        });
    }
    // POZİTİF liste: şablon YALNIZ denetimde (tatbikat da taşımaz — v1).
    if (!sahaTuruAlaniVarMi(g.tip, 'sablon') && sablon !== null) {
        ctx.addIssue({
            code: 'custom',
            path: ['formTemplateId'],
            message: 'Form şablonu yalnız denetimde seçilir',
        });
    }
    const tatbikat = g.tatbikat ?? null;
    if (sahaTuruAlaniVarMi(g.tip, 'tatbikat') && tatbikat === null) {
        ctx.addIssue({
            code: 'custom',
            path: ['tatbikat'],
            message: 'Tatbikat için tür ve senaryo girin',
        });
    }
    if (!sahaTuruAlaniVarMi(g.tip, 'tatbikat') && tatbikat !== null) {
        ctx.addIssue({
            code: 'custom',
            path: ['tatbikat'],
            message: 'Tatbikat alanları yalnız tatbikatta girilir',
        });
    }
});
exports.sahaTuruEkipEkleSchema = zod_1.z.object({ personId: zod_1.z.uuid() });
exports.GOZLEM_METIN_MAX = 4000;
exports.gozlemOlusturSchema = zod_1.z.object({
    tip: exports.gozlemTipiSchema,
    metin: zod_1.z.string().trim().min(1).max(exports.GOZLEM_METIN_MAX),
});
/**
 * Kapanış (S4 · S9): lider seçer. `bulguGozlemIds` = seçilen UYGUNSUZ serbest
 * gözlemler; `bulguFormMaddeleri` = seçilen ✗ form maddelerinin alan kodları
 * (yalnız denetimde). İkisi de boş olabilir — bulgusuz kapanış meşrudur.
 */
exports.sahaTuruKapatSchema = zod_1.z.object({
    bulguGozlemIds: zod_1.z.array(zod_1.z.uuid()).max(200).default([]),
    bulguFormMaddeleri: zod_1.z.array(zod_1.z.string().trim().min(1).max(60)).max(200).default([]),
});
// ── Yanıt şemaları ────────────────────────────────────────────────────────
/** Sayaç — DÖF sayacıyla AYNI şekil (0/0 renksiz · x/x yeşil · 0/x kırmızı · kısmi sarı). */
exports.sahaTuruBulguOzetiSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().nonnegative(),
    acik: zod_1.z.number().int().nonnegative(),
});
exports.sahaTuruEkipUyesiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    /** Lider = açan hesabın kişisi (varsa). */
    lider: zod_1.z.boolean(),
});
exports.gozlemFotografiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    /**
     * P13-c (madde 227) — silme kapısı SATIR BAŞINA: tur yazma adımları → KAPALI
     * TUR (durum kilidi, holding dahil) → sahiplik (yükleyen VEYA holding yön.).
     * ~~`silebilir` boolean (yalnız yükleyen)~~ söküldü.
     */
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.gozlemSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int().nonnegative(),
    tip: exports.gozlemTipiSchema,
    metin: zod_1.z.string().min(1),
    /** Dolu ise gözlem kapanışta seçilen bir FORM MADDESİNDEN doğdu. */
    alanKodu: zod_1.z.string().nullable(),
    /** Maddenin atfının o anki KOPYASI (S5). */
    atif: zod_1.z.string().nullable(),
    bulguSecildi: zod_1.z.boolean(),
    /** Bulgu doğduysa uygunsuzluk kaydı — kendi hayatını yaşar. */
    nonconformityId: zod_1.z.uuid().nullable(),
    nonconformityTakipNo: zod_1.z.string().nullable(),
    /** Bulgunun DÖF durumu (uygunsuzluk kapanış türetmesi) — bulgusuz gözlemde null. */
    bulguKapali: zod_1.z.boolean().nullable(),
    fotograflar: zod_1.z.array(exports.gozlemFotografiSchema),
    createdAt: zod_1.z.iso.datetime(),
});
exports.gozlemListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.gozlemSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
/** Denetim formunun ✗ maddeleri — kapanış seçim listesi (kontrolOzeti.uygunsuzlar'dan). */
exports.denetimUygunsuzMaddesiSchema = zod_1.z.object({
    alanKodu: zod_1.z.string().min(1),
    etiket: zod_1.z.string().min(1),
    cevapEtiketi: zod_1.z.string().min(1),
    atif: zod_1.z.string().nullable(),
});
exports.sahaTuruDenetimFormuSchema = zod_1.z.object({
    formSubmissionId: zod_1.z.uuid(),
    durum: zod_1.z.enum(['draft', 'submitted']),
    uygunsuzMaddeler: zod_1.z.array(exports.denetimUygunsuzMaddesiSchema),
});
/** Ekran düğmelerinin kaynağı — SUNUCUDAN (§2.40; kapı ile görünürlük tek yüklem). */
exports.sahaTuruYetkileriSchema = zod_1.z.object({
    /** Açık tur ∧ şapka ∧ bahçe — ekip/gözlem/fotoğraf yazma. */
    yazabilir: zod_1.z.boolean(),
    /** `sahaTuruKapanisEngeli` null ise true. */
    kapatabilir: zod_1.z.boolean(),
    /** Pasif kapanış düğmesinin YANINDA gösterilen sebep (G5). */
    kapanisEngeli: zod_1.z.string().nullable(),
    /** Denetimde form doldurma düğmesi: açık ∧ yazabilir ∧ gönderilmiş form yok. */
    formDoldurabilir: zod_1.z.boolean(),
    /** Tur eki (dış rapor) yükleme: şapka ∧ bahçe — açık VEYA kapalı turda (rapor sonradan gelir). */
    ekYukleyebilir: zod_1.z.boolean(),
    /** P13 — tur yazma kapısı (şapka → turun işyeri/lokasyon bahçesi → arşiv) + sebep. */
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * Madde 230 — kapalı turda tur ekini silmek GEREKÇE ister (yalnız holding
     * yön.; gerekçesiz 422). Gözlem fotoğrafı istisnaya girmez.
     */
    ekSilmeGerekceZorunlu: zod_1.z.boolean(),
    /**
     * P13 — denetim formu = FORM MOTORUNUN kapısı (şapka ya da atama → bahçe
     * turun lokasyonuyla → arşiv → tur açık). Eski bayrak tur yazma kapısına
     * bakıyordu; atamayla dolduran şapkasız kullanıcı düğmeyi göremiyordu.
     */
    formKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.tatbikatSchema = zod_1.z.object({
    /** G4.1 — ÇOKLU, sabit sözlük sırasında, tekrarsız. */
    turler: zod_1.z.array(acil_durum_1.tatbikatTuruSchema).min(1),
    senaryo: zod_1.z.string().min(1),
    sureDakika: zod_1.z.number().int().positive().nullable(),
    tahliyeKisiSayisi: zod_1.z.number().int().min(0).nullable(),
    /** Katılan ekipler — görevlendirme türü nüshası (ad + kütüphane ref'i). */
    ekipler: zod_1.z.array(zod_1.z.object({ gorevlendirmeTuruId: zod_1.z.uuid(), ad: zod_1.z.string().min(1), kutuphaneRef: zod_1.z.uuid() })),
});
/** Tur eki (E5 — dış tatbikat raporu; `stored_file`ın on üçüncü bağı). Tutanak PDF ile yan yana durur. */
exports.sahaTuruEkiSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    yukleyenEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
    /**
     * P13-c (madde 227) — tur eki silme kapısı: tur yazma → KAPALI TUR → sahiplik.
     * ⚠️ Dış tatbikat raporu KAPALI tura da yüklenir (E5) ve tur yeniden açılmaz
     * → o ek yüklendiği andan kalıcıdır; ekran sebebi bir kez yazar.
     */
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.sahaTuruOzetSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
    tip: exports.sahaTuruTipiSchema,
    durum: exports.sahaTuruDurumuSchema,
    tarih: zod_1.z.iso.date(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    locationNodeId: zod_1.z.uuid().nullable(),
    locationAd: zod_1.z.string().nullable(),
    birimRefId: zod_1.z.uuid().nullable(),
    birimAd: zod_1.z.string().nullable(),
    formTemplateId: zod_1.z.uuid().nullable(),
    formTemplateAd: zod_1.z.string().nullable(),
    liderAppUserId: zod_1.z.uuid(),
    liderEtiket: zod_1.z.string().min(1),
    ekipSayisi: zod_1.z.number().int().nonnegative(),
    /** TÜRETİLİR — kolon yok (S9). */
    bulguOzeti: exports.sahaTuruBulguOzetiSchema,
    olumluSayisi: zod_1.z.number().int().nonnegative(),
    gozlemSayisi: zod_1.z.number().int().nonnegative(),
    kapanisAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    /** E5 — yalnız tatbikatta dolu (kolonlar turun satırında, katılan ekipler bağ tablosunda). */
    tatbikat: exports.tatbikatSchema.nullable(),
});
exports.sahaTuruDetaySchema = exports.sahaTuruOzetSchema.extend({
    ekip: zod_1.z.array(exports.sahaTuruEkipUyesiSchema),
    /** Denetimde: kap içindeki form kaydı (yoksa null); gözlem turunda null. */
    denetimFormu: exports.sahaTuruDenetimFormuSchema.nullable(),
    /** Tur ekleri — dış tatbikat raporu vb. (E5: tutanak PDF ile yan yana). */
    ekler: zod_1.z.array(exports.sahaTuruEkiSchema),
    /** Madde 230 — kaldırılan tur eklerinin izi (kim · ne zaman · gerekçe). */
    silinenEkler: zod_1.z.array(kapi_durumu_1.silinenEkSchema),
    yetkiler: exports.sahaTuruYetkileriSchema,
});
exports.sahaTuruListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.sahaTuruOzetSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
/** Tur açma ekranının seçenekleri — bahçeden (ikinci filtre yazılmaz). */
exports.sahaTuruSecenekleriSchema = zod_1.z.object({
    isyerleri: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string().min(1),
        companyId: zod_1.z.uuid(),
        companyAd: zod_1.z.string().min(1),
        lokasyonlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    })),
    birimler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    /** Tatbikatta seçilebilir ekipler — görevlendirme türü nüshaları (acil durum ekipleri, gizli olmayan). */
    acilDurumEkipleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1), kutuphaneRef: zod_1.z.uuid() })),
    /** Denetimde seçilebilir şablonlar — yayınlı sürümü olan, arşivsiz, izin türü formu OLMAYAN. */
    sablonlar: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        kod: zod_1.z.string().min(1),
        ad: zod_1.z.string().min(1),
        /** ✏️ F4·S6 (T5): şablonun KAPSAMI — geçerli olduğu işyerleri. Ekran
         *  seçili işyerinin bu kümede olup olmadığına bakar; şirket/düzey
         *  türetmesi YAPMAZ (eski `companyId` süzgeci düştü — §2.16/B3). */
        kapsamIsyeriIdleri: zod_1.z.array(zod_1.z.uuid()),
    })),
});
exports.ekipAdayiSchema = zod_1.z.object({ personId: zod_1.z.uuid(), adSoyad: zod_1.z.string().min(1) });
exports.ekipAdaylariSchema = zod_1.z.array(exports.ekipAdayiSchema);
// ── Liste süzgeci ─────────────────────────────────────────────────────────
/**
 * P4 — sunucu süzgeci. Tanınmayan değer sessizce "tümü"ye DÜŞMEZ (400 —
 * tur 10 / K5 dersi). Tarih aralığı KESİŞİM değil, tur günü tek gün olduğu
 * için basit aralıktır.
 */
exports.sahaTuruListeSuzgeciSchema = zod_1.z.object({
    durum: exports.sahaTuruDurumuSchema.optional(),
    tip: exports.sahaTuruTipiSchema.optional(),
    workplaceId: zod_1.z.uuid().optional(),
    tarihBaslangic: zod_1.z.iso.date().optional(),
    tarihBitis: zod_1.z.iso.date().optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
/** Çıktı antetindeki süzgeç özeti — ekran ve Excel AYNI metni okur (P4). */
function sahaTuruSuzgecOzeti(s, isyeriAd) {
    const kalemler = [];
    if (s.durum)
        kalemler.push(`Durum: ${exports.SAHA_TURU_DURUM_ETIKETI[s.durum]}`);
    if (s.tip)
        kalemler.push(`Tip: ${exports.SAHA_TURU_TIP_ETIKETI[s.tip]}`);
    if (s.workplaceId)
        kalemler.push(`İşyeri: ${isyeriAd ?? s.workplaceId}`);
    if (s.tarihBaslangic || s.tarihBitis) {
        kalemler.push(`Tarih: ${s.tarihBaslangic ?? '…'} – ${s.tarihBitis ?? '…'}`);
    }
    return kalemler.length > 0 ? kalemler : ['Süzgeç yok — tüm kayıtlar'];
}
//# sourceMappingURL=saha-turu.js.map